import axios from '../xhr_libs/axios';
import { processResponse } from '.';

export const getGeneratorsAPI = async (orgId) => {
  return processResponse(await axios.get(`/resource/generators/${orgId}`, {}));
};
